import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { POKER_COLORS } from '../../theme/designSystem';

interface PokerCardProps extends BoxProps {
  glow?: boolean;
}

const PokerCard: React.FC<PokerCardProps> = ({ glow = false, children, ...props }) => {
  return (
    <Box
      bg={POKER_COLORS.cardBg}
      border={`1px solid ${POKER_COLORS.cyan}`}
      borderRadius="12px"
      p={6}
      boxShadow={glow ? `0 0 20px ${POKER_COLORS.cyan}44` : 'lg'}
      transition="all 0.3s"
      _hover={glow ? { boxShadow: `0 0 30px ${POKER_COLORS.cyan}66` } : {}}
      {...props}
    >
      {children}
    </Box>
  );
};

export default PokerCard;